import React from "react";
import { Check, ChevronDown } from "lucide-react";

import chartStyles from "./singleAssetPerformance.module.css";

// 图表控制栏的下拉（行情走势 / 持仓盈亏率、折线图 / K线图，2026-10-29 改版）。
// options: [[value, label, disabledReason?]]；disabledReason 非空时该项置灰并作为 title 提示。
export function ChartSelect({ label, value, options, onChange }) {
  const [open, setOpen] = React.useState(false);
  const rootRef = React.useRef(null);
  React.useEffect(() => {
    if (!open) return undefined;
    const close = (event) => {
      if (event.type === "keydown" ? event.key === "Escape" : !rootRef.current?.contains(event.target)) setOpen(false);
    };
    document.addEventListener("pointerdown", close);
    document.addEventListener("keydown", close);
    return () => {
      document.removeEventListener("pointerdown", close);
      document.removeEventListener("keydown", close);
    };
  }, [open]);
  const current = options.find(([key]) => key === value);
  return (
    <div className={chartStyles.chartSelect} ref={rootRef}>
      <button type="button" aria-label={label} aria-haspopup="listbox" aria-expanded={open} onClick={() => setOpen((on) => !on)}>
        {current?.[1]}<ChevronDown size={14} aria-hidden="true" />
      </button>
      {open && (
        <div role="listbox" aria-label={label}>
          {options.map(([key, text, disabledReason]) => (
            <button
              key={key}
              type="button"
              role="option"
              aria-selected={key === value}
              disabled={Boolean(disabledReason)}
              title={disabledReason || undefined}
              onClick={() => { onChange(key); setOpen(false); }}
            >
              {text}{key === value && <Check size={14} aria-hidden="true" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
